/**
 * @generated SignedSource<<0adcd318910dd2fa92cdf6400ebcabfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedHeroCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_viewer">;
  readonly " $fragmentType": "PdpRespSharedHeroCarousel_viewer";
};
export type PdpRespSharedHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespSharedHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedHeroCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemMediaItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f4650e0e935ef948ed079092cb37c5ef";

export default node;
